import Products from './Products1';
import Cart from './Cart';
import { CartProvider } from '../context/CartContext';

export default function Dashboard() {
  return (
    <>
      <CartProvider>
        <div className="flex">
          <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
            <div className="relative z-0 flex flex-row-reverse flex-1 overflow-hidden">
              <main
                style={{ background: "#fffff" }}
                className="relative z-0 flex-1 border-r pt-4 border-black overflow-y-auto focus:outline-none xl:order-last overflow-y-scroll scrollbar-hide"
              >
                <br />
                <p style={{textAlign:'center', fontWeight:'700', fontSize:'30px', color:'#505050'}}>Sewanagala Ayurvedaya</p>
                <p style={{textAlign:'center', fontWeight:'500', fontSize:'14px', color:'#5a5a5a'}}>~Harmony Through Ayurvedic Excellence~</p>
                
                <Products />
              </main>
              <div className='lg:block hidden'>
                <aside className="relative bg-[#0e1227] w-[400px] h-[96.8vh] flex-shrink-0 overflow-y-auto">
                  <Cart />
                </aside>
              </div>
            </div>
          </div>
        </div>
      </CartProvider>
    </>
  );
}
